import { MatchPlayerModel } from "../../../../api/repositories/stats/models/matches"
import { HeroIconImage, MapImage } from "../../ui/file-contents"

export const MapBlock: React.FC<{
    players: MatchPlayerModel[]
    isDuo: boolean
    className?: string
}> = ({ players, isDuo, className }) => {
    const playersWithTowerPlaces = players.filter(f => f.towerPosition && f.heroName);

    return playersWithTowerPlaces.length > 0
        ? <div className={`w-[380px] h-[380px] sm:w-[450px] sm:h-[450px] relative ${className}`}>
            <MapImage isDuo={isDuo} />
            {
                playersWithTowerPlaces.map((player, i) => (
                    <HeroIconImage
                        className={`absolute ${getIconPos(player.towerPosition!, i)}`}
                        key={i}
                        name={player.heroName!}
                    />
                ))
            }
        </div>
        : null

    function getIconPos(towerPlace: number, playerIndex: number): string {
        if (isDuo) {
            const isEvenPlayer = playerIndex % 2 == 0;
            switch (towerPlace) {
                case 1:
                    return isEvenPlayer
                        ? 'bottom-[40px] left-[160px] sm:bottom-[50px] sm:left-[192px]'
                        : 'bottom-[40px] left-[190px] sm:bottom-[50px] sm:left-[225px]';
                case 2:
                    return isEvenPlayer
                        ? 'bottom-[160px] left-[40px] sm:bottom-[192px] sm:left-[50px]'
                        : 'bottom-[190px] left-[40px] sm:bottom-[225px] sm:left-[50px]';
                case 3:
                    return isEvenPlayer
                        ? 'top-[35px] left-[160px] sm:top-[40px] sm:left-[192px]'
                        : 'top-[35px] left-[190px] sm:top-[40px] sm:left-[225px]';
                case 4:
                    return isEvenPlayer
                        ? 'top-[160px] right-[40px] sm:top-[192px] sm:right-[50px]'
                        : 'top-[190px] right-[40px] sm:top-[225px] sm:right-[50px]';
                default:
                    return '';
            }
        } else {
            switch (towerPlace) {
                case 1: return 'bottom-[70px] left-[64px] sm:bottom-[82px] sm:left-[76px]';
                case 2: return 'bottom-[48px] left-[197px] sm:bottom-[55px] sm:left-[235px]';
                case 3: return 'bottom-[199px] left-[45px] sm:bottom-[235px] sm:left-[52px]';
                case 4: return 'top-[60px] right-[65px] sm:top-[72px] sm:right-[78px]';
                case 5: return 'top-[39px] right-[195px] sm:top-[45px] sm:right-[235px]';
                case 6: return 'top-[190px] right-[44px] sm:top-[228px] sm:right-[52px]';
                default: return '';
            }
        }
    }
}
